import { render, staticRenderFns } from "./DataLoaderHome.vue?vue&type=template&id=e5a60758&"
import script from "./DataLoaderHome.vue?vue&type=script&lang=js&"
export * from "./DataLoaderHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports